import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable()
export class OtherService {
  constructor(private http: Http) {}

  private baseurl = environment.apiBaseUrl;

  // save entry into others table when other field is added by clicking on add other button
  saveOtherField(parent, child, data) {
    return this.http
      .post(`${this.baseurl}/other/save`, { parent, child, data })
      .map((res: Response) => res.json());
  }

  // get all other fields according to parent i.e from which table this request is made
  getOtherFields(projectId, parent) {
    return this.http
      .post(`${this.baseurl}/other/get`, { projectId, parent })
      .map((res: Response) => res.json());
  }

  // remove other field entry when click on trasgh button of other field
  removeOtherField(data) {
    return this.http
      .post(`${this.baseurl}/other/remove`, { data })
      .map((res: Response) => res.json());
  }

  // update value of other fields onchange event, update both part of other field i.e. name & value
  updateFieldNameValue(id, data, variableName) {
    return this.http
      .post(`${this.baseurl}/other/update`, { id, data, variableName })
      .map((res: Response) => res.json());
  }

  // get value part of other fields
  getFieldValue(id) {
    return this.http
      .post(`${this.baseurl}/other/getFieldValue`, { id })
      .map((res: Response) => res.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/service/other.service.ts